"use client";
import { Tour } from "@graphql/types";
import { sendGTMEvent } from "@next/third-parties/google";

export async function captureTourEvent(tour: Tour, userId: number) {
  sendGTMEvent({
    event: "view_item",
    ecommerce: {
      items: [
        {
          item_id: tour?.id,
          item_name: tour?.title,
          price: tour?.price.amount,
          currency: tour?.price.currency.id,
          guide_id: tour?.supplier?.id,
          customer_id: userId,
          item_category: tour?.city?.country?.name || tour?.country?.name,
          item_category2: tour?.city?.name,
        },
      ],
    },
  });
}
